import { combineActions, handleActions } from 'redux-actions'
import {
  actionsTypesGenerator,
  onRequest,
  onSuccess,
  onFailure,
} from 'utils/reduxHelpers'
import initialState from '../initialState'

const LOGIN_USER = actionsTypesGenerator('LOGIN_USER')
const LOGIN_WITH_SOCIAL = actionsTypesGenerator('LOGIN_WITH_SOCIAL')
const LOGOUT_USER = actionsTypesGenerator('LOGOUT_USER')
const SIGNUP_USER = actionsTypesGenerator('SIGNUP_USER')
const UPDATE_USER = actionsTypesGenerator('UPDATE_USER')
const FETCH_USER = actionsTypesGenerator('FETCH_USER')
const CLEAR_AUTH_STATE = 'CLEAR_AUTH_STATE'
const SET_AUTH_TOKENS = 'SET_AUTH_TOKENS'

export const clearAuthState = () => ({
  type: CLEAR_AUTH_STATE,
})

export const setAuthTokens = (tokens) => ({
  type: SET_AUTH_TOKENS,
  payload: tokens,
})

export const login = (email, password, locale) => ({
  types: LOGIN_USER,
  callAPI: {
    method: 'POST',
    path: '/v2/auth/login',
    params: {
      locale,
    },
    data: {
      email,
      password,
      preventToastNotification: true,
    },
  },
})

export const loginWithSocial = ({
  provider,
  locale,
  code,
  scope,
  utm_source,
  utm_medium,
  utm_campaign,
  utm_term,
  utm_content,
}) => ({
  types: LOGIN_WITH_SOCIAL,
  callAPI: {
    method: 'POST',
    path: `/login/${provider}/${locale}/callback`,
    params: {
      code,
      scope,
      utm_source,
      utm_medium,
      utm_campaign,
      utm_term,
      utm_content,
    },
    data: {
      preventToastNotification: true,
    },
  },
})

export const logout = () => ({
  types: LOGOUT_USER,
  callAPI: {
    method: 'POST',
    path: '/v2/auth/logout',
    data: {
      preventToastNotification: true,
    },
  },
})

export const signup = (params) => ({
  types: SIGNUP_USER,
  callAPI: {
    method: 'POST',
    path: '/v2/users',
    params,
    entity: 'User',
    data: {
      preventToastNotification: true,
    },
  },
})

export const updateUser = (userUuid, data) => ({
  types: UPDATE_USER,
  callAPI: {
    method: 'PATCH',
    entity: 'User',
    path: `/v2/users/${userUuid}`,
    data,
  },
})

export const fetchUser = () => ({
  types: FETCH_USER,
  callAPI: {
    method: 'GET',
    entity: 'User',
    path: `/v2/users/me`,
  },
})

export default handleActions(
  {
    CLEAR_AUTH_STATE: () => ({
      ...initialState.auth,
    }),
    [SET_AUTH_TOKENS]: (state, { payload }) => {
      return {
        ...state,
        token: payload.access_token,
        refresh_token: payload.refresh_token,
      }
    },
    [combineActions(
      LOGIN_USER.request,
      LOGIN_WITH_SOCIAL.request,
      LOGOUT_USER.request,
      SIGNUP_USER.request,
    )]: onRequest,
    [combineActions(
      LOGIN_USER.success,
      LOGIN_WITH_SOCIAL.success,
      SIGNUP_USER.success
    )]: (state, { response }) => {
      return onSuccess({
        ...state,
        token: response.access_token,
        refresh_token: response.refresh_token,
      })
    },
    [LOGOUT_USER.success]: () => {
      return onSuccess({
        ...initialState.auth,
      })
    },
    [combineActions(UPDATE_USER.success, FETCH_USER.success)]: (
      state,
      { response }
    ) => {
      return onSuccess({
        ...state,
        user: response.data,
      })
    },
    [combineActions(
      LOGIN_USER.failure,
      LOGIN_WITH_SOCIAL.failure,
      LOGOUT_USER.failure,
      SIGNUP_USER.failure,
      UPDATE_USER.failure,
      FETCH_USER.failure,
    )]: onFailure,
  },
  initialState.auth
)
